(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-container-resize.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-container-resize.js');
"use strict";

const {
  useEffect,
  useState
} = React;

const debounceTime = 250;
const useContainerResize = containerEl => {
  const [containerWidth, setContainerWidth] = useState((containerEl === null || containerEl === void 0 ? void 0 : containerEl.clientWidth) || 0);

  useEffect(() => {
    let unobserveFn;
    let clearResizeTimerFn;
    if (containerEl) {
      const localContainerEl = containerEl;
      let resizeTimer;
      clearResizeTimerFn = () => {
        if (resizeTimer) {
          clearTimeout(resizeTimer);
        }
      };
      const runResizeTimer = () => {
        clearResizeTimerFn();
        resizeTimer = setTimeout(() => {
          setContainerWidth(localContainerEl.clientWidth);
        }, debounceTime);
      };
      const resizeObserver = new ResizeObserver(() => {
        runResizeTimer();
      });
      unobserveFn = () => {
        resizeObserver.unobserve(localContainerEl);
      };
      resizeObserver.observe(localContainerEl);
      runResizeTimer();
    }
    return () => {
      if (clearResizeTimerFn) {
        clearResizeTimerFn();
      }
      if (unobserveFn) {
        unobserveFn();
      }
    };
  }, [containerEl]);
  return {
    containerWidth
  };
};
setGlobal('svs.components.tipsen.drawSelectorComponents.hooks.useContainerResize', useContainerResize);

 })(window);